<template>
  <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M7 10V13M17 10V13M17 13V19C17 19.5523 16.5523 20 16 20H8C7.44772 20 7 19.5523 7 19V13M17 13L21.0188 10.5887C21.538 10.2772 21.6635 9.57933 21.2852 9.10651L19.6304 7.038C18.5662 5.70773 17.1402 4.71339 15.524 4.17467V4.17467C15.2346 4.0782 14.9218 4.23461 14.8253 4.52401L14.6325 5.10263C14.2548 6.23572 13.1944 7 12 7V7C10.8056 7 9.74524 6.23572 9.36754 5.10263L9.17467 4.52402C9.0782 4.23461 8.76539 4.0782 8.47599 4.17467V4.17467C6.85983 4.71339 5.43381 5.70773 4.3696 7.038L2.71479 9.10651C2.33654 9.57933 2.46195 10.2772 2.98116 10.5887L7 13"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
